import type { PublicationContentTag } from '~/interfaces/publication';

const getContentTagIds = (tags: string[], contentTags: PublicationContentTag[] = []) => {
  if (!tags) {
    return [];
  }

  const contentTagIdByDisplay: Record<string, string> = contentTags.reduce(
    (pv, cv) => {
      pv[cv.display] = cv.id;
      return pv;
    },
    {} as Record<string, string>,
  );

  try {
    return tags.map((tag) => {
      return contentTagIdByDisplay[tag] || tag;
    });
  } catch (_e) {
    return [];
  }
};

export default getContentTagIds;
